import { useEffect, useState } from 'react';
import { billingApi } from '../services/api';
import { BillingPlan } from '../types';

/**
 * Fetches the current user's billing plan once (mirrors useAdminAccess.ts).
 * Cached in state; on error we leave the plan unknown (null) rather than
 * guessing, so callers should render nothing until a plan is known.
 */
export const useBillingStatus = (enabled: boolean) => {
  const [plan, setPlan] = useState<BillingPlan | null>(null);

  useEffect(() => {
    if (!enabled) {
      setPlan(null);
      return;
    }

    let cancelled = false;

    billingApi
      .getStatus()
      .then((status) => {
        if (!cancelled) {
          setPlan(status.plan);
        }
      })
      .catch(() => {
        if (!cancelled) {
          setPlan(null);
        }
      });

    return () => {
      cancelled = true;
    };
  }, [enabled]);

  return plan;
};
